import createVueApp from '@phoenix/createVueApp';
import Journal from '@maison/components/organisms/Journal.vue';

document.querySelectorAll('.phoenix-journal').forEach((el) => {
  const app = createVueApp();
  app.component('Journal', Journal);
  app.mount(el);
});
